module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "summary"
    }
  }, [_c('h1', [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    staticClass: "img-centre",
    staticStyle: {
      "width": "1.58291in"
    },
    attrs: {
      "alt": "Device",
      "src": "media/file0.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Device")])]), _vm._v(" "), _c('p', [_vm._v("A group of unlikely heroes from the opposite sides of the track embarks on the most ultimate human adventure surrounding an ancient alien transportation device. The four main characters travel through time in search of answers and a way home, but end up making a difference in terms of helping to solve an age-old mystery and avert a disaster in the future from occurring. They learn a lot about themselves in the process.")]), _vm._v(" "), _c('p', [_vm._v("A simple twist of fate")]), _vm._v(" "), _c('p', [_vm._v("A secret destiny")]), _vm._v(" "), _c('p', [_vm._v("Angels and Demons")]), _vm._v(" "), _c('p', [_vm._v("Familia Omnia EST")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9da684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 69
// module chunks = 0